// extracted by mini-css-extract-plugin
export default {"footer":"s_bY","footerColumns":"s_ck","menuColumn":"s_cl","legal":"s_cm","trademarks":"s_cn"};